/* eslint-disable */
// HISTÓRICO CONGELADO de F3d (ingresosER, Bloques B y C): copia literal del código anterior de registrosHardware / registrosGestion de src/pages/ERv2/ingresosER.js. Producción lo usa para los meses < 2026-10 (corteHistorico.js). No editar.
import { parseLocalYMD } from "../../fechasFuturosPanel";
import { crearRegistroFinancieroER } from "../../../pages/ERv2/registroFinancieroER";

// H7 — idéntico al de usePublicidadCalcs.js/useContratosCalcs.js (mismo wrapper compartido,
// no una copia con otro nombre: 10.243).
const fechaLocalDeNegocio = (fechaStr) => parseLocalYMD(fechaStr) || new Date(NaN);


/**
 * Registros de ingreso de HARDWARE (`negocios_carteleria`) de un (pais, ano) — réplica de
 * `useHardwareCalcs.js:54-215` (`calcIngresosHardware`), un registro por cada tramo/cuota que
 * el hook viejo suma a `mapa[mes]`. **P2.117-2, NO corregido acá** (fallback CAPEX-sin-desglose
 * usa fin de mes para la conversión, no el día 1 de la factory compartida — se replica tal cual).
 *
 * `fecha` del registro (para el futuro Criterio 1, sección 6 riesgo 3 del diseño — NO consumido
 * todavía): la fecha REAL del tramo/factura cuando existe (desglose, otros-CAPEX, OPEX facturado
 * real, OPEX-por-cuota con match en `costosGestion`); `null` ("sin fecha propia", decisión 2)
 * cuando el monto es una proyección/estimación sin documento real (CAPEX sin desglose, OPEX por
 * cuota sin match) — el mes/año de ubicación en la tabla NO cambia por esto, solo el futuro TC.
 * La conversión EXTRANJERA→LOCAL (UF/USD del tramo) se calcula AHORA, con la MISMA fecha que usa
 * el hook viejo para ese fin (fin de mes en los casos sin documento real) — eso no cambia.
 *
 * @param {object} p
 * @param {Array} p.negocios - Filas de `negocios_carteleria` del país.
 * @param {"Chile"|"Perú"} p.pais
 * @param {number} p.ano
 * @param {Function} p.getUFValue - `(fechaStr) => number` (solo aplica si pais==="Chile").
 * @param {Function} p.getDolarValue - `(fechaStr) => number`, YA bound al país.
 * @param {Array|null} [p.costosGestion] - `costos_gestion_contenidos`, para la fecha real de
 *   factura del camino OPEX-por-cuota (null = sin esa tabla, igual que año anterior/Perú hoy).
 * @returns {Array} RegistroFinancieroER[]
 */
export const registrosHardware = ({ negocios, pais, ano, getUFValue, getDolarValue, costosGestion = null }) => {
  const registros = [];
  const defaultMoneda = pais === "Chile" ? "UF" : "PEN";

  (negocios || []).forEach((n) => {
    if (!n.incluye_hardware || n.eliminada) return;
    if (!["100%", "Activo"].includes(n.estado)) return;
    const moneda = (n.moneda_hardware || defaultMoneda).toUpperCase();
    let yaProcesadoConDesglose = false;

    const convertir = (monto, fechaParaTC) => {
      if (moneda === "UF" && pais === "Chile") return Math.round(monto * getUFValue(fechaParaTC));
      if (moneda === "US$" || moneda === "USD") return Math.round(monto * getDolarValue(fechaParaTC));
      return monto;
    };

    const push = (fecha, mesIndice, montoLocal, tramo) => {
      registros.push(
        crearRegistroFinancieroER({
          fecha,
          ano,
          mesIndice,
          montoLocal,
          bloque: "B",
          concepto: "ingreso_hardware",
          pais,
          meta: { id: n.id, origen: "negocios_carteleria", tramo },
        })
      );
    };

    // CAPEX con desglose de pagos (tramos reales, 1 registro por tramo facturado).
    if (
      n.modalidad === "CAPEX" &&
      Array.isArray(n.detalle_pagos_hardware) &&
      n.detalle_pagos_hardware.some((p) => p.monto != null)
    ) {
      n.detalle_pagos_hardware.forEach((pago) => {
        const fechaTramo = pago.facturafecha || pago.fecha_factura;
        if (!fechaTramo || pago.monto == null) return;
        const fecha = fechaLocalDeNegocio(fechaTramo);
        const mes = fecha.getMonth();
        const anoTramo = fecha.getFullYear();
        if (anoTramo !== ano) return;
        const fechaUsada = String(fechaTramo).split("T")[0];
        push(fechaUsada, mes, convertir(Number(pago.monto), fechaUsada), "capex_desglose");
      });
      yaProcesadoConDesglose = true;
    }

    // OTROS CAPEX (mismo patrón, tabla separada).
    if (n.modalidad === "CAPEX" && Array.isArray(n.detalle_otros_hardware) && n.detalle_otros_hardware.length > 0) {
      n.detalle_otros_hardware.forEach((pago) => {
        if (!pago.fecha_factura || pago.monto == null) return;
        const fecha = fechaLocalDeNegocio(pago.fecha_factura);
        const mes = fecha.getMonth();
        const anoTramo = fecha.getFullYear();
        if (anoTramo !== ano) return;
        const fechaUsada = String(pago.fecha_factura).split("T")[0];
        push(fechaUsada, mes, convertir(Number(pago.monto), fechaUsada), "capex_otros");
      });
    }

    // CAPEX sin desglose (fallback) / OPEX — mutuamente exclusivos, igual que el hook viejo.
    if (n.modalidad === "CAPEX" && n.fecha_cierre && !yaProcesadoConDesglose) {
      const fechaCierre = fechaLocalDeNegocio(n.fecha_cierre);
      const mesCierre = fechaCierre.getMonth();
      const anoCierre = fechaCierre.getFullYear();
      if (anoCierre !== ano) return;
      const ultimoDia = new Date(ano, mesCierre + 1, 0);
      const fechaStr = ultimoDia.toISOString().split("T")[0];
      const montoLocal = convertir(Number(n.monto_hardware) || 0, fechaStr);
      // Sin tramo real: "sin fecha propia" (decisión 2) — el mes es el de fecha_cierre; la
      // conversión (ya hecha arriba con fin de mes, P2.117-2) no cambia.
      push(null, mesCierre, montoLocal, "capex_sin_desglose");
    } else if (n.modalidad === "OPEX" && n.cuota_hardware_opex && n.fecha_cierre) {
      const pantallas = Number(n.cantidad_pantallas) || 1;
      const cuotaBase = Number(n.cuota_hardware_opex);

      // Modo "facturado real": meses_facturacion con entries tipo "opex".
      const mesesFact = Array.isArray(n.meses_facturacion) ? n.meses_facturacion : [];
      const opexEntries = mesesFact.filter((e) => e && e.tipo === "opex" && e.facturafecha);
      if (opexEntries.length > 0) {
        opexEntries.forEach((e) => {
          // Parseo manual (NO fechaLocalDeNegocio) — réplica deliberada, ver Anexo A del diseño.
          const [fy, fm] = e.facturafecha.split("-").map(Number);
          if (fy !== ano) return;
          const idx = fm - 1;
          if (idx < 0 || idx > 11) return;
          const montoLocal = convertir(cuotaBase * pantallas, e.facturafecha);
          push(String(e.facturafecha).slice(0, 10), idx, montoLocal, "opex_facturado_real");
        });
        return;
      }

      // Fallback por cuota: itera desde fecha_cierre, cruzando años si corresponde.
      const fechaCierre = fechaLocalDeNegocio(n.fecha_cierre);
      const mesCierreOpex = fechaCierre.getMonth();
      const anoCierre = fechaCierre.getFullYear();
      const totalCuotas = Number(n.num_cuotas) || Number(n.plazo_contrato_meses) || 36;

      let cuotaActual = 0;
      let anoActual = anoCierre;
      let mesActual = mesCierreOpex;

      while (cuotaActual < totalCuotas) {
        if (anoActual === ano && mesActual >= 0 && mesActual < 12) {
          let fechaPropia = null;
          let fechaParaTC;
          if (costosGestion) {
            const registro = costosGestion.find(
              (c) =>
                Number(c.negocio_id) === n.id &&
                Number(c.mes) === mesActual + 1 &&
                Number(c.ano) === ano &&
                c.fecha_factura
            );
            const ultimoDia = new Date(ano, mesActual + 1, 0);
            fechaParaTC = registro?.fecha_factura?.split("T")[0] || ultimoDia.toISOString().split("T")[0];
            fechaPropia = registro?.fecha_factura ? fechaParaTC : null;
          } else {
            const ultimoDia = new Date(ano, mesActual + 1, 0);
            fechaParaTC = ultimoDia.toISOString().split("T")[0];
          }
          const montoLocal = convertir(cuotaBase * pantallas, fechaParaTC);
          push(fechaPropia, mesActual, montoLocal, "opex_por_cuota");
        }
        cuotaActual++;
        mesActual++;
        if (mesActual >= 12) {
          mesActual = 0;
          anoActual++;
        }
        if (anoActual > ano + 1) break;
      }
    }
  });
  return registros;
};

// ─── Gestión: helpers privados, réplica exacta de useGestionCalcs.js (10.243) ──────────────

// `useGestionCalcs.js:40-77` — null si el negocio no tiene `meses_facturacion` poblado.
const getCuotasFacturadasPorMes = (negocio, year) => {
  const entries = Array.isArray(negocio.meses_facturacion) ? negocio.meses_facturacion : [];
  if (entries.length === 0) return null;
  const incluyeContenidos = !!negocio.incluye_contenidos;
  const result = Array.from({ length: 12 }, () => ({ gestion: 0, contenidos: 0, fechaFactura: null }));
  let hasAny = false;
  entries.forEach((e) => {
    if (!e || !e.facturafecha) return;
    if (e.tipo !== "gestion" && e.tipo !== "contenidos") return;
    const [fy, fm] = e.facturafecha.split("-").map(Number);
    if (fy !== year) return;
    const idx = fm - 1;
    if (idx < 0 || idx > 11) return;
    result[idx][e.tipo] += 1;
    result[idx].fechaFactura = e.facturafecha;
    hasAny = true;
  });
  if (incluyeContenidos) {
    const contInicio = negocio.contenidos_fecha_inicio ? new Date(negocio.contenidos_fecha_inicio + "T00:00:00") : null;
    const contFin = negocio.contenidos_fecha_fin ? new Date(negocio.contenidos_fecha_fin + "T00:00:00") : null;
    result.forEach((slot, idx) => {
      if (slot.gestion > 0 && slot.contenidos === 0) {
        const slotDate = new Date(year, idx, 1);
        const enRango = (!contInicio || slotDate >= contInicio) && (!contFin || slotDate <= contFin);
        if (enRango) slot.contenidos = slot.gestion;
      }
    });
  }
  return hasAny ? result : null;
};

// `useGestionCalcs.js:115-120`.
const contenidosVigenteEnMes = (negocio, year, monthIndex) => {
  const contInicio = negocio.contenidos_fecha_inicio ? new Date(negocio.contenidos_fecha_inicio + "T00:00:00") : null;
  const contFin = negocio.contenidos_fecha_fin ? new Date(negocio.contenidos_fecha_fin + "T00:00:00") : null;
  const slotDate = new Date(year, monthIndex, 1);
  return (!contInicio || slotDate >= contInicio) && (!contFin || slotDate <= contFin);
};

/**
 * Registros de ingreso de GESTIÓN & CONTENIDOS (`negocios_carteleria`) de un (pais, ano) —
 * réplica de las variantes PAÍS-ESPECÍFICAS `useGestionCalcs.js:485-627`
 * (`ingresosGestionContenidosMensualChile`/`...Peru`), NO de la variante "genérica"
 * (`ingresosGestionContenidosMensual`, líneas 311-401): esa variante hace, SOLO en su camino
 * fallback, una búsqueda adicional de `fecha_factura` real en `costos_gestion_contenidos` que
 * las variantes país-específicas NO hacen (usan directamente fin de mes) — una 3ª asimetría de
 * TC, no catalogada en P2.117, encontrada al escribir este paso. Se eligen las variantes
 * país-específicas porque son las que alimentan `gestionMensualesCombinados` (la única agregación
 * cross-country hoy) y porque son simétricas entre sí — NO se corrige acá, se documenta en el
 * cierre de este paso para una futura corrección.
 *
 * Perú usa el mecanismo `toPEN` (TC MENSUAL `dolarMensualPeru[mes]`, sin granularidad de día —
 * P2.117-3, NO corregido acá); Chile usa `convertirAMonedaLocal` (factory bound a "Chile", TC de
 * la fecha puntual real o fin de mes en el fallback).
 *
 * @param {object} p
 * @param {Array} p.negocios - Filas de `negocios_carteleria` del país.
 * @param {"Chile"|"Perú"} p.pais
 * @param {number} p.ano
 * @param {Function} [p.convertirAMonedaLocal] - Factory bound al país (solo si pais==="Chile").
 * @param {Array} [p.dolarMensualPeru] - Array(12) (solo si pais==="Perú").
 * @param {object} [p.dolarFallback] - `{ Chile, Perú }` (solo si pais==="Perú").
 * @returns {Array} RegistroFinancieroER[]
 */
export const registrosGestion = ({ negocios, pais, ano, convertirAMonedaLocal, dolarMensualPeru, dolarFallback }) => {
  const registros = [];

  const toPEN = (monto, moneda, mesIndice) => {
    if (!monto) return 0;
    const m = (moneda || "PEN").toUpperCase();
    if (m === "USD" || m === "US$") return monto * (dolarMensualPeru[mesIndice] || dolarFallback["Perú"]);
    return monto;
  };

  (negocios || []).forEach((negocio) => {
    if (negocio.eliminada || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;
    const fechaInicio = fechaLocalDeNegocio(negocio.fecha_inicio);
    const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
    if (plazoMeses === 0) return;
    const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
    const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
    const contenidosUnitario = negocio.incluye_contenidos ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;

    const montoGestion = (monto, moneda, mes1, fechaOverride) =>
      pais === "Perú"
        ? toPEN(monto, moneda, mes1 - 1)
        : convertirAMonedaLocal(monto, moneda, pais, negocio.id, mes1, ano, fechaOverride);

    const push = (fecha, mesIndice, montoLocal, concepto) => {
      registros.push(
        crearRegistroFinancieroER({
          fecha,
          ano,
          mesIndice,
          montoLocal,
          bloque: "C",
          concepto,
          pais,
          meta: { id: negocio.id, origen: "negocios_carteleria" },
        })
      );
    };

    const cuotasFacturadas = getCuotasFacturadasPorMes(negocio, ano);
    if (cuotasFacturadas) {
      cuotasFacturadas.forEach((slot, m) => {
        if (slot.gestion === 0 && slot.contenidos === 0) return;
        if (slot.gestion > 0 && gestionUnitario > 0) {
          const monto = montoGestion(
            gestionUnitario * pantallas * slot.gestion,
            negocio.moneda_gestion,
            m + 1,
            slot.fechaFactura
          );
          push(slot.fechaFactura, m, monto, "ingreso_gestion");
        }
        if (slot.contenidos > 0 && contenidosUnitario > 0) {
          const monedaContenidos =
            pais === "Perú" ? negocio.moneda_contenidos || negocio.moneda_gestion : negocio.moneda_contenidos;
          const monto = montoGestion(
            contenidosUnitario * pantallas * slot.contenidos,
            monedaContenidos,
            m + 1,
            slot.fechaFactura
          );
          push(slot.fechaFactura, m, monto, "ingreso_contenidos");
        }
      });
      return;
    }

    for (let m = 0; m < 12; m++) {
      const ultimoDiaMes = new Date(ano, m + 1, 0);
      if (fechaInicio > ultimoDiaMes) continue;
      const fechaParaUF = ultimoDiaMes.toISOString().split("T")[0];
      if (gestionUnitario > 0) {
        const monto = montoGestion(gestionUnitario * pantallas, negocio.moneda_gestion, m + 1, fechaParaUF);
        // Sin factura real (camino fallback): "sin fecha propia" (decisión 2) — el mes es m.
        push(null, m, monto, "ingreso_gestion");
      }
      if (contenidosUnitario > 0 && contenidosVigenteEnMes(negocio, ano, m)) {
        const monedaContenidos =
          pais === "Perú" ? negocio.moneda_contenidos || negocio.moneda_gestion : negocio.moneda_contenidos;
        const monto = montoGestion(contenidosUnitario * pantallas, monedaContenidos, m + 1, fechaParaUF);
        push(null, m, monto, "ingreso_contenidos");
      }
    }
  });
  return registros;
};
